<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Upload File PDF</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="9" md="9" lg="9" xl="9">
            <v-file-input
              v-model="file"
              label="File"
              accept=".pdf"
              prepend-icon="mdi-file-pdf-box"
              placeholder="Upload PDF File"
              outlined
              dense
              clearable
            ></v-file-input>
          </v-col>
          <v-col cols="3" md="3" lg="3" xl="3">
            <v-btn color="success" @click="getOcr"><v-icon>mdi-file-upload</v-icon></v-btn>
          </v-col>
          <v-col cols="12" v-if="loading" class="text-center">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-col>
          <v-col cols="12" v-else>
            <v-row v-if="invoice">
              <v-col cols="12" md="6" lg="4" xl="4">Vendor</v-col>
              <v-col cols="12" md="6" lg="8" xl="8">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="item.vendor_name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="4" xl="4">Invoice#</v-col>
              <v-col cols="12" md="6" lg="8" xl="8"
                ><v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="item.invoice_number"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="6" lg="4" xl="4">PO#</v-col>
              <v-col cols="12" md="6" lg="8" xl="8"
                ><v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="item.reference_number"
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="6" lg="4" xl="4">Date</v-col>
              <v-col cols="12" md="6" lg="8" xl="8"
                ><v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="item.invoice_date"
                  hint="YYYY-MM-DD ex: 2023-01-01"
                  persistent-hint
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="6" lg="4" xl="4">Amount</v-col>
              <v-col cols="12" md="6" lg="8" xl="8">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model.number="item.invoice_amount"
                  type="number"
                  :hint="formatPrice(item.invoice_amount)"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" md="6" lg="4" xl="4">Tax#</v-col>
              <v-col cols="12" md="6" lg="8" xl="8">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="item.tax_number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" lg="4" xl="4">Date</v-col>
              <v-col cols="12" md="6" lg="8" xl="8">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="item.tax_date"
                  hint="YYYY-MM-DD ex: 2023-01-01"
                  persistent-hint
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" @click="close">
          close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="uploadFile">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-upload",
  props: {
    dialog: Boolean,
    invoice: Boolean,
  },
  data() {
    return {
      file: null,
      item: {},
      loading: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    uploadFile() {
      this.$emit("save", this.item);
      this.$emit("close");
    },
    async getOcr() {
      const formData = new FormData();
      formData.append("file", this.file);

      this.loading = true;
      await this.$store
        .dispatch("purchaseInvoice/ocr", { body: formData, params: { invoice: this.invoice } })
        .then(response => {
          this.item = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.loading = false;
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(4).split(".");
      val[0] = val[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return val.join(",");
    },
  },
};
</script>

<style></style>
